import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
let Protect=(props)=>{

    
    let navigate = useNavigate();
    let {Component} = props;

    useEffect(()=>{
        let login = localStorage.getItem("login");
        if(!login){
            localStorage.setItem("loginStatus" , "Please login to view dashboard!");
            navigate("/LoginPage",  {replace: true});  
        }
    }, []);



    return(
        <Component 
        finaldata={props.finaldata}
        Successandrerrorfun={props.Successandrerrorfun}
        Getphydata={props.Getphydata} 
        Getpasspoetdata={props.Getpasspoetdata}   
        GetExpData = {props.GetExpData} 
        GetTechnicalData = {props.GetTechnicalData} 
        GetComputerData = {props.GetComputerData} 
        GetAcademicData = {props.GetAcademicData} 
        getdatafromgetter={props.getdatafromgetter}/>  
    );
    
}
export default Protect;